import React, {lazy} from 'react';
import {ROUTE_REPORT_UNLOCK} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const ReportUnlockApproval = lazy(() =>
  import('../../../screens/ReportUnlockApproval')
    .then(module => ({default: module.ReportUnlockApproval})));

const ReportUnlockApprovalNavigation = [
  {
    path: ROUTE_REPORT_UNLOCK,
    loader: authLoader,
    element: (
      <ReportUnlockApproval />
    ),
  },
];

export default ReportUnlockApprovalNavigation;
